/* Copyright 2021, Milkdown by Mirone. */
import { css } from '@emotion/css';
import { createCmd, createCmdKey } from '@milkdown/core';
import { createMark, createShortcut, markRule } from '@milkdown/utils';
import { toggleMark } from 'prosemirror-commands';
import { SupportedKeys } from '../supported-keys';
const id = 'code_inline';
export const ToggleInlineCode = createCmdKey();
export const codeInline = createMark((_, utils) => {
    const style = utils.getStyle(({ palette, size, font }) => css `
                background-color: ${palette('neutral')};
                color: ${palette('background')};
                border-radius: ${size.radius};
                font-weight: 500;
                font-family: ${font.code};
                padding: 0 0.2rem;
            `);
    return {
        id,
        schema: {
            excludes: '_',
            parseDOM: [{ tag: 'code' }],
            toDOM: (mark) => ['code', { class: utils.getClassName(mark.attrs, 'code-inline', style) }],
        },
        parser: {
            match: (node) => node.type === 'inlineCode',
            runner: (state, node, markType) => {
                state.openMark(markType);
                state.addText(node.value);
                state.closeMark(markType);
            },
        },
        serializer: {
            match: (mark) => mark.type.name === id,
            runner: (state, _, node) => {
                state.addNode('inlineCode', undefined, node.text || '');
                return true;
            },
        },
        inputRules: (markType) => [markRule(/(?:^|[^`])(`([^`]+)`)$/, markType)],
        commands: (markType) => [createCmd(ToggleInlineCode, () => toggleMark(markType))],
        shortcuts: {
            [SupportedKeys.CodeInline]: createShortcut(ToggleInlineCode, 'Mod-e'),
        },
    };
});
//# sourceMappingURL=code-inline.js.map